import cookies from 'js-cookie'

export default {
  user: null,
  token: cookies.get('token') || null,
  permissoes: null,
  contrato: null
}
